import styled from 'styled-components';
import { BodyShort01, ProductiveHeading07 } from 'components/styles';

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-05) 0;
`;

export const SectionContent = styled.div`
  padding-bottom: var(--spacing-05);
`;

export const Description = styled.div`
  padding-left: var(--spacing-04);
  ${BodyShort01};
`;

export const PrimaryTitle = styled.span`
  ${ProductiveHeading07};
  margin-bottom: 0;
`;

export const SecondaryTitle = styled.span``;

export const FeatureControlWrapper = styled.div`
  padding: var(--spacing-03) var(--spacing-04);
  display: flex;
  align-items: center;
`;
